<template>
  <div class="col d-flex">
    <div class="card flex-grow-1">
      <h6 class="card-header">Participants</h6>
      <div class="card-body position-relative text-center" role="button" @click="filters && (filters.statusFilter = 'inscrit')">
        <div><b class="text-muted" style="font-size: 3rem;">{{peopleInscrits}}</b> personnes inscrites</div>
        <span class="small">
          <div class="small" v-if="(filters?.hideCompanions != true) || (filters?.transportFilter === 'all' && filters?.transportOption === null)">
            <span v-if="(filters?.hideCompanions != true)">dont <b>{{ inscritsParticipants ?? 0 }}</b>&nbsp;</span>
            <span v-if="(filters?.transportFilter === 'all' && filters?.transportOption === null)">sur <b>{{totalParticipants ?? 0}}</b>&nbsp;</span>participants
          </div>
          <div class="small">
            <span v-if="(filters?.hideCompanions != true) && (companionOnlyCount > 0)"> et <b>{{companionOnlyCount}}</b> accompagnants</span>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { useBoardFilters } from '@/compositions/useBoardFilters';

  const { participations, filters } = useBoardFilters({ applyStatus: false })

  const peopleInscrits = computed(() => {
    let result = participations.value.filter(x=>x.invitation?.completionDate != null && x.invitation?.refusalDate == null).length ?? 0;
    if(filters?.value.hideCompanions != true) {
      result += companionOnlyCount.value;
    }
    return result;
  });

  const inscritsParticipants = computed(() => {
    return participations.value.filter(x=>x.invitation?.completionDate != null && x.invitation?.refusalDate == null).length ?? 0;
  });

  const totalParticipants = computed(() => {
    return participations.value.length ?? 0;
  });

  const companionOnlyCount = computed(() => {
    return participations.value.filter(x=>x.invitation?.completionDate != null && x.invitation?.refusalDate == null).reduce((a, b) => a + (b.companions?.length ?? 0), 0);
  });
</script>
